import { render, staticRenderFns } from "./Settlement.vue?vue&type=template&id=6b08ce65"
import script from "./Settlement.vue?vue&type=script&lang=js"
export * from "./Settlement.vue?vue&type=script&lang=js"
import style0 from "./Settlement.vue?vue&type=style&index=0&id=6b08ce65&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports